import actionTypes from '../constants/action-types';

const finishPublishing = ({
  siteUrl,
  withUpsell,
  isPublished,
  partnerId,
  isThirdPartyDomain,
  hasUntranslatedCustomCode,
}) => ({
  type: actionTypes.FINISH_PUBLISHING,
  payload: {
    siteUrl,
    withUpsell,
    isPublished,
    partnerId,
    isThirdPartyDomain,
    hasUntranslatedCustomCode,
  },
});

export default finishPublishing;
